// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2IMRx","form":"styles_form__23uYJ"};